module.exports = __webpack_public_path__ + "5dd7401114bf981b54e6411b6da47729.svg";


//////////////////
// WEBPACK FOOTER
// ./components/top-nav/src/img/logo-powered.svg
// module id = 2399
// module chunks = 0